<template>
  <div>
    <router-link
      v-for="(subLink, index) in link.children"
      :key="index"
      :to="'/' + link.name + '/' + subLink.name"
      :class="{ 'active': ($router.currentRoute.fullPath === '/' + link.name + '/' + subLink.name) || ((prevRoute === '/' + link.name + '/' + subLink.name) && ($router.currentRoute.name == 'DHR Detailed' || $router.currentRoute.name == 'DHR Master'))}"
    >{{ subLink.title }}</router-link>
  </div>
</template>

<script>
export default {
  computed: {
    prevRoute: function () {
      return localStorage.getItem('lastRoute')
    }
  },
  props: {
    link: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/nav";
</style>
